<template>
  <!-- SOLUM 페이지 공용 컨테이너.
       App.vue 의 상단 네비바 (Menu 드롭다운 포함) 가 모든 페이지에서 보이므로
       별도 좌측 사이드바를 두지 않는다. 이 컴포넌트는 padding/배경 통일과
       향후 공용 chrome 확장을 위해 유지. -->
  <div class="sl-root">
    <main class="sl-main">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'SolumLayout',
};
</script>

<style scoped>
.sl-root {
  min-height: calc(100vh - 60px); /* App.vue 의 60px 상단바 제외 */
  background: #f8fafc;
  font-family: 'Noto Sans KR', 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.sl-main {
  padding: 20px 24px;
  min-width: 0;
}
@media (max-width: 768px) {
  .sl-main { padding: 14px 12px; }
}
</style>
